"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulgariaTranslations = void 0;
var _types = require("../../../types");
const BulgariaTranslations = exports.BulgariaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Съжаляваме!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'В момента с тази страница има проблем',
  [_types.ErrorPageTranslationKey.notFound]: 'Страницата, която търсите, не съществува',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Страницата, която се опитвате да посетите, е ограничена и не са изпълнени всички критерии.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Моля, свържете се с екипа за поддръжка на Орифлейм по имейл:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Заявеният URL бе отхвърлен!'
};
